module.exports = __webpack_public_path__ + "img/logo QLayout.45416ada.svg";